import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseStatusPipe',
})
export class CaseStatusPipe implements PipeTransform {
  transform(
    value: string,
    args: { useRole: number | undefined; type: 'Notice' | 'Search' }
  ): string {
    switch (value) {
      case '1':
        return 'CaseStatus.1';
      case '10':
      case '10,30,150':
        return 'CaseStatus.10';
      case '30':
        return args.type === 'Notice' && args.useRole === 0
          ? 'News.CaseStatus.30-0'
          : `CaseStatus.30-${args.useRole}`;
      case '20':
        return 'CaseStatus.20';
      case '40':
        return args.type === 'Notice' ? 'News.CaseStatus.40' : 'CaseStatus.40';
      case '50':
        return 'CaseStatus.50';
      case '60':
        return 'CaseStatus.60';
      case '80':
      case '80,81,110,111,140,141,152,153':
      case '80,81,90,110,111,120,140,141,152,153':
        return 'CaseStatus.80';
      case '120':
        return `CaseStatus.120-${args.useRole}`;
      case '140':
      case '141':
      case '142':
        return 'CaseStatus.140';
      case '90':
        return `CaseStatus.90-${args.useRole}`;
      case '110':
        return 'CaseStatus.110';
      case '170':
        return 'CaseStatus.170';
      case '70':
      case '70,100,130,151':
      case '70,100,130,151,154,161':
        return args.type === 'Notice' ? 'News.CaseStatus.70' : 'CaseStatus.70';
      case '130':
        return 'CaseStatus.130';
      case '100':
        return 'CaseStatus.100';
      case '160':
        return 'CaseStatus.160';
      case '150':
        return `CaseStatus.150-${args.useRole}`;
      case '151':
      case '152':
      case '153':
      case '154':
      case '161':
        return 'CaseStatus.70';
      case '180':
        return 'CaseStatus.180';
      case '190':
        return 'CaseStatus.190';
      case '200':
        return 'CaseStatus.200';
      case '210':
        return 'CaseStatus.210';
      // 最新消息 - 下載合約
      case '-1':
        return 'CaseStatus.-1';
      // 最新消息 - 下載登記文件
      case '-2':
        return 'CaseStatus.-2';
      // 保險專區 - 報價完成
      case '-3':
        return 'CaseStatus.-3';
      // 保險專區 - 投保完成
      case '-4':
        return 'CaseStatus.-4';
      // 最新消息 - 預覽合約
      case '-5':
        return 'CaseStatus.-5';
      case '500':
        return 'CaseStatus.500';
      case '600':
        return 'CaseStatus.600';
      case '700':
        return 'CaseStatus.700';
      default:
        return '';
    }
  }
}
